import {useCallback, useEffect, useState, useRef} from 'react';
import {useRouter} from 'next/router';
import {CirclePay} from '../utils/payment/circle-pay-api';
import {mixpanelTrack} from '../contexts/analytics-context/utils';

// Payment status from circle pay for a cash payment

const checkout = new CirclePay();

export const usePaymentStatus: () => {
  userEmail: string;
  paymentStatus: string;
  // pollForPaymentsDetail: (paymentId: string) => void;
} = () => {
  // const router = useRouter();

  // const [paymentStatus, setPaymentStatus] = useState('');
  // const [userEmail, setUserEmail] = useState('');

  // const paymentIdFromUrl = router.query.paymentId;

  // const polling = useRef(false);
  // const pollingId = useRef(0);

  // const stopPolling: () => void = () => {
  //   clearInterval(pollingId.current);
  //   polling.current = false;
  // };

  // const getPaymentStatus = useCallback(async (paymentId: string) => {
  //   try {
  //     const payment = await checkout.getPayment(paymentId);
  //     setPaymentStatus(payment.status);
  //     setUserEmail(payment.metadata.email);
  //     if (payment.status === 'action_required') {
  //       window.location.replace(payment.requiredAction.redirectUrl);
  //     }
  //     if (
  //       payment.status === 'confirmed' ||
  //       payment.status === 'failed' ||
  //       payment.status === 'paid'
  //     ) {
  //       mixpanelTrack(`Fiat purchases ${payment.status}`);
  //       stopPolling();
  //     }
  //   } catch (e) {
  //     mixpanelTrack(`Fiat purchases failed`);
  //     stopPolling();
  //   }
  // }, []);

  // const pollForPaymentsDetail: (id: string) => void = useCallback(
  //   (id) => {
  //     polling.current = true;
  //     pollingId.current = window.setInterval(() => {
  //       getPaymentStatus(id);
  //     }, 3000);
  //   },
  //   [getPaymentStatus],
  // );

  // useEffect(() => {
  //   if (paymentIdFromUrl && typeof paymentIdFromUrl === 'string') {
  //     pollForPaymentsDetail(paymentIdFromUrl);
  //   }
  // }, [paymentIdFromUrl, pollForPaymentsDetail, router]);

  return {
    userEmail: '',
    paymentStatus: '',
    // pollForPaymentsDetail,
  };
};
